import React from 'react';
import BaseSelect from '../common/BaseSelect';

class RatingSelect extends BaseSelect {
  /**
   * renders UI
   */
  render() {
    const {
      isDisabled,
      inputStyles,
      noErrorState,
      dropDownStyles,
      xDeleteChar,
      hideXDelete,
      inputClassNames,
      outerWrapStyles,
      hideErrorMessage,
      isErrorTriggered,
      dropDownClassNames,
      outerWrapClassNames,
      requiredTextStyles,
      requiredTextClassNames,
      xDeleteClassNames,
      xDeleteStyles,
      arrowStyles,
      arrowClassNames,
      validationRules: { required },
      placeholder,
      errorMessage,
    } = this.props;

    const {
      value,
      isValid,
      uiValue,
      isTouched,
      isFocused,
      userQuery,
    } = this.state;

    const isErrorState = (!noErrorState
      && !isValid && !isFocused && isTouched)
      || (!noErrorState && !isValid && isErrorTriggered && !isFocused);

    const options = this.getOptions();
    // what the user sees

    let outerWrapState = '';
    if (isDisabled) outerWrapState = '--disabled';
    else if (isValid && isFocused) outerWrapState = '--valid-dropdown';
    else if (isValid) outerWrapState = '--valid';
    else if (isFocused) outerWrapState = '--focused';
    else if (isErrorState) outerWrapState = '--error';

    let fullOuterWrapClassNames = `base-select__outer-wrap${outerWrapState} ${outerWrapClassNames}`;
    if (required) fullOuterWrapClassNames += ' base-select__outer-wrap--required';
    
    const isValuePresent = value && String(value).length > 0;

    return (
      <div className="rating-select-wrap">
        <div
          style={outerWrapStyles}
          onClick={this.handleFocus}
          className={fullOuterWrapClassNames}
          ref={(node) => { this.node = node }}
        >
          {!value && placeholder && (
            <div className="base-select__placeholder">
              {placeholder}
            </div>
          )}
          {(!hideXDelete && isValuePresent) && (
            <span
              style={xDeleteStyles}
              onClick={this.handleXDelete}
              className={`base-select__x-delete ${xDeleteClassNames}`}
            >
              {xDeleteChar}
            </span>
          )}
          {(hideXDelete) && (
            <span
              style={arrowStyles}
              onClick={(e) => this.handleArrow(e)}
              className={`${isFocused ? `base-select__arrow--up` : `base-select__arrow--down` } ${arrowClassNames}`}
            />
          )}
          <input // <- this is the "fake input"
            type="text"
            value={userQuery}
            onKeyDown={this.handleKeyDown}
            onChange={this.handleUserQuery}
            className="base-select__hidden-input"
            ref={(hiddenInput) => { this.hiddenInput = hiddenInput }}
          />
          <div // <- this is the user facing "input"
            className={`base-select__input ${inputClassNames}`}
            style={inputStyles}
          >
            {uiValue}
          </div>
          {(!hideErrorMessage && isErrorState) && (
            <div
              style={requiredTextStyles}
              onClick={this.handleFocus}
              className={`base-select__required ${requiredTextClassNames}`}
            >
              {errorMessage}
            </div>
          )}
          {isFocused && (
            <ul
              ref={(dropDown) => { this.dropDown = dropDown }}
              style={dropDownStyles}
              className={`base-select__dropdown ${dropDownClassNames}`}
            >
              {options}
            </ul>
          )}
        </div>
        <ul className="rating-select-text">
            <li><b>1 = Poor</b> = Needs Improvement, Incosistent, Presents Barrier to Success, Needs Coaching</li>
            <li><b>2 = Average</b> = Moderately Skilled, May Be Inconsistent, Overall Success, May Need Coaching w/ Some Skills</li>
            <li><b>3 = Excellent</b> = Mastery, Consistent, Highest Success, Benchmark Execution</li>
        </ul>
      </div>
    )
  }
}

export default RatingSelect;


// WEBPACK FOOTER //
// ./src/features/agent-coaching/RatingSelect.js